export enum SingleAlertType {
  UserAlert = 0,
  DriverCardReadingAlert = 1,
  DriverCardExpireAlert = 2,
  VehicleCardReadingAlert = 3,
  VehicleCalibrationAlert = 4,
  VehicleInsuranceValidityDateAlert = 5,
  VehicleCheckupDateAlert = 6,
  FranceDeclarationAlert = 7,
  GermanyDeclarationAlert = 8,
  AustriaDeclarationAlert = 9,
  DrivingLicenceValidToAlert = 10,
  HollandDeclarationAlert = 11,
}
